import { useEffect, useState } from "react";
import { isCallActive, subscribeCallActive } from "@/lib/call-audio-coordinator";

/**
 * React subscription to the global call-active pub/sub.
 *
 * Returns `true` while any SIP / WebRTC / PSTN call is ringing, connecting,
 * or connected. Use this to disable / grey-out background media controls
 * (e.g. the Sounds of Home radio player) so users can't fight the call audio
 * focus mid-call.
 */
export function useCallActive(): boolean {
  const [active, setActive] = useState<boolean>(() => isCallActive());
  useEffect(() => subscribeCallActive(setActive), []);
  return active;
}
